module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10203.2d009690.jpg";